module.exports = __webpack_public_path__ + "img/hengyang.ecbdcd1f.png";